import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService, ToastMessage } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: false,
  template: `
    <div style="position:fixed;top:1rem;right:1rem;z-index:2000;display:flex;flex-direction:column;gap:0.5rem;max-width:380px;">
      @for (msg of messages; track msg.id) {
        <div class="alert" [class.alert-success]="msg.severity === 'success'"
             [class.alert-error]="msg.severity === 'error'"
             [class.alert-warning]="msg.severity === 'warn' || msg.severity === 'warning'"
             [class.alert-info]="msg.severity === 'info'"
             style="box-shadow:0 4px 12px rgba(0,0,0,0.15);min-width:280px;">
          <div style="flex:1;">
            <div style="font-weight:600;margin-bottom:2px;">{{ msg.summary }}</div>
            <div style="font-size:0.8rem;">{{ msg.detail }}</div>
          </div>
          <button style="background:none;border:none;cursor:pointer;font-size:1.1rem;color:inherit;padding:0 4px;"
                  (click)="removeMessage(msg)">&times;</button>
        </div>
      }
    </div>
  `
})
export class ToastComponent implements OnInit, OnDestroy {
  messages: ToastMessage[] = [];
  private sub!: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.message$.subscribe((msg) => {
      this.messages.push(msg);
      const life = msg.life ?? 3000;
      setTimeout(() => this.removeMessage(msg), life);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  removeMessage(msg: ToastMessage): void {
    const idx = this.messages.indexOf(msg);
    if (idx >= 0) {
      this.messages.splice(idx, 1);
    }
  }
}
